import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../context/AppContext';
import tagsArray from '../../helpers/tagsArray';
import './SearchBar.css';

function SearchBar() {
  const {
    productList,
    searchTerm,
    setSearchTerm,
    setFiltredList,
    gender,
    setGender,
    category,
    setCategory,
  } = useContext(AppContext);

  // Lista de produtos filtrados
  const [filteredProducts, setFilteredProducts] = useState(productList);

  const handleFilters = () => {
    // Filtrar produtos com base no gênero
    const filteredByGender = gender === 'todos' ? productList : productList.filter(product => product.gender.includes(gender));
    
    // Filtrar produtos com base na categoria
    const filteredByCategory = category === 'todas' ? filteredByGender : filteredByGender.filter(product => product.tags.includes(category));

    // Filtrar produtos com base no nome
    const filteredByName = searchTerm === '' ? filteredByCategory : filteredByCategory.filter(product => product.name.toLowerCase().includes(searchTerm.toLowerCase()));

    // Atualizar a lista de produtos filtrados
    setFilteredProducts(filteredByName);

    // Atualizar a lista no contexto
    setFiltredList(filteredByName);
  };

  const handleChange = ({ target }) => {
    const { name, value } = target;
    switch (name) {
      case 'search-input':
        setSearchTerm(value);
        break;
      case 'gender':
        setGender(value);
        break;
      case 'category':
        setCategory(value);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    handleFilters();
  }, [searchTerm, gender, category]);

  return (
    <main>
      <section className='search-section'>
        <section className="search-container">
          <input
            name="search-input"
            className="search-input"
            type="text"
            placeholder='Busca por nome'
            onChange={(e) => handleChange(e)}
            value={searchTerm}
          />
          <img
            className="search-icon"
            src="https://i.postimg.cc/pTQqHHL9/Vectorlupa.png"
            alt="search.png"
          />
        </section>
        <section>
          <label id="category-filter">
            Categorias:
            <select
              name="category"
              id="category-input"
              onChange={(e) => handleChange(e)}
              value={category}
            >
              <option value="todas">todas</option>
              {tagsArray.sort().map((e) => (
                <option key={e} value={e}>
                  {e}
                </option>
              ))}
            </select>
          </label>
          <label>
            Gênero:
            <select
              name="gender"
              onChange={(e) => handleChange(e)}
              value={gender}
            >
              <option value="todos">Todos</option>
              <option value="masculino">Masculino</option>
              <option value="feminino">Feminino</option>
            </select>
          </label>
        </section>
      </section>
      {searchTerm ? (
        <p className="search-term">{`Procurando por: ${searchTerm}`}</p>
      ) : null}
    </main>
  );
}

export default SearchBar;
